import { render, staticRenderFns } from "./ControlProperties.vue?vue&type=template&id=25fc0d93&"
import script from "./ControlProperties.vue?vue&type=script&lang=js&"
export * from "./ControlProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports